import { render, staticRenderFns } from "./cheliangxinxiSG.vue?vue&type=template&id=183f3270&scoped=true&"
import script from "./cheliangxinxiSG.vue?vue&type=script&lang=js&"
export * from "./cheliangxinxiSG.vue?vue&type=script&lang=js&"
import style0 from "./cheliangxinxiSG.vue?vue&type=style&index=0&id=183f3270&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f3270",
  null
  
)

export default component.exports